import { runInAction } from "mobx";
import moment from "moment";
import { APIClient } from "Application";

import { GETRotaByDateEndPoint, GETRotaByDateRequest, GETRotaByDateResponse } from "../EndPoint/GETRotaByDateEndPoint";
import { POSTRotaEndPoint, POSTRotaRequest, POSTRotaResponse } from "../EndPoint/POSTRotaEndPoint";
import { MentorStatusEnum } from "Views/Mentors/Mentors/Enums/MentorStatusEnum";
import type { WeeklyRotaViewModel } from "../WeeklyRotaViewModel";

export class APIManager {
    public apiClient = new APIClient();

    constructor(private viewModel: WeeklyRotaViewModel) {}

    public async loadRotaByDate(): Promise<void> {
        this.viewModel.managers.ui.setIsLoading(true);

        try {
            const request: GETRotaByDateRequest = {
                startDate: moment(this.viewModel.managers.mobx.weeklyRotaDetailViewModel.model.startDate).format("YYYY-MM-DD"),
                mentorStatusType: MentorStatusEnum.Current,
            };
            await this.apiClient.sendAsync(new GETRotaByDateEndPoint(), request);

            if (this.apiClient.IsRequestSuccessful) {
                const response = this.apiClient.Response<GETRotaByDateResponse>();
                runInAction(() => {
                    const detailModel = this.viewModel.managers.mobx.weeklyRotaDetailViewModel.model;
                    detailModel.rotaId = response.rota !== null ? response.rota?.id : null;
                    detailModel.mentorAvailability = response.rota !== null ? response.mentorAvailability : [];
                });
            }
        } finally {
            this.viewModel.managers.ui.setIsLoading(false);
        }
    }

    public async postRotaAsync(): Promise<void> {
        this.viewModel.managers.ui.setIsProcessing(true);

        try {
            const detailModel = this.viewModel.managers.mobx.weeklyRotaDetailViewModel.model;
            const request: POSTRotaRequest = {
                startDate: moment(detailModel.startDate).format("YYYY-MM-DD"),
                copyFromPreviousWeek: this.viewModel.model.copyFromPreviousWeek,
                selectedWeekStartDate: moment(this.viewModel.model.startDate).format("YYYY-MM-DD"),
            };
            await this.apiClient.sendAsync(new POSTRotaEndPoint(), request);

            if (this.apiClient.IsRequestSuccessful) {
                const response = this.apiClient.Response<POSTRotaResponse>();
                runInAction(() => {
                    detailModel.rotaId = response.rota !== null ? response.rota?.id : null;
                    detailModel.mentorAvailability = response.rota !== null ? response.mentorAvailability : [];
                });
            }
        } finally {
            this.viewModel.managers.ui.setIsProcessing(false);
        }
    }

    public resetError(): void {
        this.apiClient.reset();
    }
}
